import { Component, Element, Event, EventEmitter, h, Host, JSX } from "@stencil/core";
import { limitSlotElements } from "../../../utils/limitSlotElements";

/**
 * UxTableBodyNeo - Experimental table body component
 * @slot - The rows of the table limited to <ux-table-row-neo>
 */
@Component({
    tag: "ux-table-body-neo",
    styleUrl: "table-body-neo.scss",
    shadow: true
})
export class TableBodyNeo {
    @Element() host!: HTMLUxTableBodyNeoElement;

    /**
     * Emits the number of rows in the table
     * @internal
     */
    @Event() rowCountChange: EventEmitter<number>;

    componentDidLoad() {
        limitSlotElements(this.host, {
            allowed: {
                default: ["ux-table-row-neo"]
            }
        });
    }

    /**
     * Handle slot change event
     */
    private handleSlotChange(element: HTMLSlotElement | null) {
        if (!element) {
            return;
        }
        const nodes = (element as HTMLSlotElement).assignedNodes().filter((item) => item.nodeName.toLowerCase() !== "#text");
        this.rowCountChange.emit(nodes.length);
    }

    render(): JSX.IntrinsicElements {
        return (
            <Host role="rowgroup">
                <slot onSlotchange={(e) => this.handleSlotChange(e.target as HTMLSlotElement)} />
            </Host>
        );
    }
}
